import { styled } from "@mui/material/styles";

// Components
import { Select, Typography } from "@mui/material";

// Themes
import { theme } from "~/components/Common";

const styledName = "WalletAddMember";

export const StyledWrapper = styled("div", { name: styledName })({
  "&": {
    display: "flex",
    flexDirection: "column",
  },
});

export const StyledUserRoleSelect = styled("div", { name: styledName })({
  "&": {
    height: "30px",
    display: "flex",
  },
});

export const StyledUserRoleIcon = styled("div", { name: styledName })({
  "&": {
    height: "30px",
    width: "30px",
    borderRadius: "100%",
    backgroundColor: theme.palette.background.default,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
});

export const StyledUserSelect = styled(Select, { name: styledName })({
  "&": {
    height: "100%",
    border: "none",
    fieldset: {
      border: "none",
    },
  },
});

export const StyledOtherUserWapper = styled("div", { name: styledName })({
  "&": {
    height: "fit-content",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    ":hover": {
      backgroundColor: theme.palette.background.default,
    },
    ":focus-within": {
      backgroundColor: theme.palette.background.default,
    },
  },
});

export const StyledOtherUserInfo = styled("div", { name: styledName })({
  "&": {
    height: "100%",
    display: "flex",
    alignItems: "center",
  },
});

export const StyledOtherUserAvatar = styled(StyledUserRoleIcon, {
  name: styledName,
})({
  "&": {
    margin: "0 6px",
  },
});

export const StyledOtherUserName = styled(Typography, { name: styledName })({
  "&": {
    fontSize: "1.4rem",
    height: "20px",
  },
});

export const StyledOtherUserInfoName = styled("div", { name: styledName })({});

export const StyledOtherUserSelect = styled(StyledUserSelect, {
  name: styledName,
})({
  "&": {
    color: theme.palette.grey[600],
  },
});

export const StyledRemoveIcon = styled("div", { name: styledName })({
  "&": {
    svg: {
      color: theme.palette.warning.main,
      ":hover": {
        color: theme.palette.warning.dark,
      },
    },
    marginRight: "10px",
    cursor: "pointer",
  },
});
